import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";
import { StagingAccessGate } from "@/app/staging-access-gate";

export function App() {
  return (
    <AppProviders>
      <StagingAccessGate>
        <AppRouter />
      </StagingAccessGate>
    </AppProviders>
  );
}
